function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_#ffffff_0%,_#f4f5f7_58%,_#e7eaef_100%)]">
      {children}
    </div>
  );
}

export default MainLayout;
